module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_GA-bd78446a27011a895f59e3559bce83f9.svg";